module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-BlkIt.69fdd85.ttf";